import { confirmAccountDeletionApi, createTipCheckoutApi, getMinVersionApi, requestAccountDeletionApi, signOutApi } from "../api";
import type { TipAmount } from "../tips";
import { CACHE_PREFIX } from "./cache";
import { notifyCacheChange } from "./changes";
import { getCache } from "./init";

export const clearClientCache = (): void => {
  getCache().removeByPrefix(CACHE_PREFIX);
  notifyCacheChange(CACHE_PREFIX);
};

export const signOut = async (refreshToken?: string): Promise<void> => {
  try {
    await signOutApi.invoke({ refreshToken });
  } catch (error) {
    console.error("Failed to sign out on the server:", error);
  } finally {
    clearClientCache();
  }
};

export const requestAccountDeletion = (source?: "web" | "mobile") => requestAccountDeletionApi.invoke({ source });

export const confirmAccountDeletion = async (token: string): Promise<void> => {
  await confirmAccountDeletionApi.invoke({ token }, { skipAuth: true });
  clearClientCache();
};

export const createTipCheckout = async (tipAmount: TipAmount): Promise<string> => (await createTipCheckoutApi.invoke({ tipAmount })).sessionUrl;

export const getMinVersion = (platform?: "ios" | "android") => getMinVersionApi.invoke({ platform });
